export default __webpack_public_path__ + "static/media/trade-in-phone.8ce91300.png";